/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membersinvitedescription2Inputs */

const en_membersinvitedescription2 = /** @type {(inputs: Membersinvitedescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anyone who opens this link in the app becomes a member right away.`)
};

const de_membersinvitedescription2 = /** @type {(inputs: Membersinvitedescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wer diesen Link in der App öffnet, wird sofort Mitglied.`)
};

/**
* | output |
* | --- |
* | "Anyone who opens this link in the app becomes a member right away." |
*
* @param {Membersinvitedescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const membersinvitedescription2 = /** @type {((inputs?: Membersinvitedescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membersinvitedescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_membersinvitedescription2(inputs)
	return de_membersinvitedescription2(inputs)
});
export { membersinvitedescription2 as "membersInviteDescription" }